export const PageSize = {
  SMALL: 5,
  MEDIUM: 20,
  LARGE: 50,
  X_LARGE: 100,
};
